define(['Promise'], function (Promise) {
    return new Promise(function (resolve) {
        if (window.guardian.css.loaded) {
            // CSS has loaded, go
            resolve();
        } else {
            // Push a listener for when the JS loads
            window.guardian.css.onLoad = resolve;
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/lib/load-css-promise.js
// module id = 425
// module chunks = 0 1